import { OnboardDialog } from 'src/components/organisms/onboard/OnboardDialog';

export const DesktopProjectTour = () => {
  return (
    <>
      <OnboardDialog open={true} handleClose={() => {}} flatMode />
    </>
  );
};
